module.exports = __webpack_public_path__ + "img/staff-1.84ce754a.png";